import * as Yup from 'yup';
import {t} from 'ttag';
import {MANUAL_TAX_TYPES} from './taxTypes';

export const validationSchema = Yup.object().shape({
  reservationCode: Yup.string()
    .nullable(),
  currencyCode: Yup.string()
    .nullable()
    .required(t`Required field.`)
    .matches(/^[A-Z]{3}$/, t`Currency should be a valid one. (ex. EUR)`),
  companyCode: Yup.string()
    .nullable()
    .required(t`Required field.`),
  documentNumber: Yup.string()
    .nullable()
    .required(t`Required field.`),
  atcMask: Yup.string()
    .nullable(),
  issueDate: Yup.string()
    .nullable(),
  modified: Yup.boolean()
    .required(t`Required field`),
  coupons: Yup.array().of(Yup.object().shape({
    originAirport: Yup.string().nullable()/*.required(t`Required field.`) and added nullable*/,
    destinationAirport: Yup.string().nullable()/*.required(t`Required field.`) and added nullable*/,
    carrier: Yup.string().nullable(),
    flightNumber: Yup.string().nullable(),
    fareBasis: Yup.string().nullable(),
    couponStatus: Yup.string().nullable(),
    datetime: Yup.string().nullable(),
  })).min(1, t`At least one coupon is required`),
  amounts: Yup.array().of(Yup.object().shape({
    type: Yup.string().required(t`Required field.`),
    value: Yup.number().required(t`Required field.`),
    currentValue: Yup.number().min(0, "Must be a positive number").required(t`Required field.`),
    currency: Yup.string().nullable(),
    modified: Yup.boolean().nullable(),
  })).min(1, t`At least one amount is required`),
  taxes: Yup.array().when('manual', {
    is: true,
    then: (schema) => schema.of(Yup.object().shape({
      taxCode: Yup.string().nullable(),
      type: Yup.string()
        .required(t`Required field.`)
        .oneOf([...MANUAL_TAX_TYPES, 'unusedTaxes'], t`Type must be one of: ${MANUAL_TAX_TYPES.join(', ')}`),
      value: Yup.number().nullable(),
      currentValue: Yup.number().min(0, 'Must be a positive number').nullable(),
      active: Yup.boolean().nullable(),
      currency: Yup.string().nullable(),
      modified: Yup.boolean().nullable(),
    })),
    otherwise: (schema) => schema.of(Yup.object().shape({
      taxCode: Yup.string().nullable(),
      type: Yup.string().nullable(),
      value: Yup.number().nullable(),
      currentValue: Yup.number().min(0, 'Must be a positive number').nullable(),
      active: Yup.boolean().nullable(),
      currency: Yup.string().nullable(),
      modified: Yup.boolean().nullable(),
    })),
  }),
  paymentOptions: Yup.array().of(Yup.object().shape({
    indicator: Yup.string().required(t`Required field`),
    value: Yup.string().required(t`Required field`),
    currentValue: Yup.number().min(0, "Must be a positive number").required(t`Required field`),
    active: Yup.boolean().nullable(),
    modified: Yup.boolean().nullable(),
  })).min(1, t`At least one payment option is required`),
  totalRefund: Yup.number().when('paymentOptions', (paymentOptions, schema) => {
    return schema.test({
      test: totalRefund => totalRefund === Number(paymentOptions?.flat()?.filter(p => p.active)?.reduce((sum, p) => sum + p.currentValue, 0)?.toFixed(2)),
      message: t`The payment options total should be equal to refund subject total`
  })}),
});
